export const getEllapsedTime = (timestamp: Date | string) => {
  const now = new Date();
  const time = typeof timestamp === 'string'
    ? Date.parse(timestamp)
    : timestamp;

  const diffMs = (Number(now) - Number(time));
  const diffMins = diffMs / 1000 / 60;
  const diffHrs = diffMins / 60;
  const diffDays = diffHrs / 24;

  if (diffMins <= 1) {
    return 'Now';
  }

  if (diffHrs <= 1) {
    return `${Math.round(diffMins)}min Ago`;
  }

  if (diffDays <= 1) {
    return `${Math.round(diffHrs)}h Ago`;
  }

  return `${Math.round(diffDays)}d Ago`;
};
